import client from './client';

export const deduLoginApi = data => client().post('/dedu-login', data);
export const deduSitesApi = data => client().get('/dedu-sites', { params: data });
export const deduCoursesApi = data => client().get('/dedu-courses', { params: data });
export const siteCoursesApi = data => client().get('/site-courses', { params: data });
export const deduTargetsApi = id => client().get(`/dedu-targets/${id}`);
